export const PURE_WEBSITE_URL = "https://erikdyrrflooring.com";
export const WWW_WEBSITE_URL = "https://www.erikdyrrflooring.com";
export const SITE_NAME = "Erik Dyrr Flooring";
export const SITE_DESCRIPTION = "Erik Dyrr flooring has been servicing the high desert region for over 20 years.";